module.exports = __webpack_public_path__ + "img/maria-de-los-milagros-jackeline-jauregui-martinez-de-aguayo.f41c653b.png";